import React from "react";
import { useTranslation } from "react-i18next";

import { useTransactions } from "../../context/TransactionsContext";

import { Miles } from "../../assets";

const Summary = () => {
  const { t } = useTranslation("summary");
  const { state } = useTransactions();
  const totalVoebizPoints = (type: string) => {
    let sum = 0;
    const totalPoints: number[] = [];

    state.transactions.forEach((transaction) => {
      totalPoints.push(transaction.voebizPoints);
    });

    if (type === "negativeNumbers") {
      totalPoints.forEach((num: number) => {
        if (num < 0) {
          sum += num;
        }
      });
      return Math.abs(sum);
    }
    totalPoints.forEach((num: number) => {
      if (num > 0) {
        sum += num;
      }
    });
    return sum;
  };

  return (
    <div className="my-transactions__summary">
      <div className="my-transactions__summary-item">
        <h5 className="my-transactions__summary-title">{t("periodSummary")}</h5>
        <span className="my-transactions__summary-date">
          {t("fromToDate", { from: state.filter.startDate, to: state.filter.endDate })}
        </span>
      </div>

      <div className="my-transactions__summary-item">
        <div className="my-transactions__summary-title--points">
          <img src={Miles} alt={t("miles")} />
          <p className="my-transactions__summary-subtitle">{t("accumulatedPoints")}</p>
        </div>

        <span className="my-transactions__summary-points">
          {Intl.NumberFormat("pt-BR").format(Number(totalVoebizPoints("positiveNumbers"))) || "-"}
        </span>
      </div>

      <div className="my-transactions__summary-item">
        <div className="my-transactions__summary-title--points">
          <img src={Miles} alt={t("miles")} />
          <p className="my-transactions__summary-subtitle">{t("redeemedPoints")}</p>
        </div>

        <span className="my-transactions__summary-points">
          {Intl.NumberFormat("pt-BR").format(Number(totalVoebizPoints("negativeNumbers"))) || "-"}
        </span>
      </div>
    </div>
  );
};

export default Summary;
